export class PreSimulatorModel {
  isNewHome: boolean;
  propertyPrice: string;
  savingsMade: string;
  mortgageAmount: string;
  termInYears: string;
  monthlyIncome: string;
  location: string;
  isHabitualHousing: boolean;
  isSubsidizedHousing: boolean;
  operationType?: number;

  constructor() {
    this.isNewHome = false;
    this.propertyPrice = '200000';
    this.savingsMade = '0';
    this.mortgageAmount = '160000';
    this.termInYears = '25';
    this.monthlyIncome = '0';
    this.location = '';
    this.isHabitualHousing = true;
    this.isSubsidizedHousing = false;
  }
}
